import { render, staticRenderFns } from "./Oneclick-terms.vue?vue&type=template&id=74a70527&"
import script from "./Oneclick-terms.vue?vue&type=script&lang=js&"
export * from "./Oneclick-terms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports